import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Box,
} from "@mui/material";

export default function QuestionDialog({
  open,
  onClose,
  onSubmit,
  proximaOrdem,
}: {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: {
    descricao: string;
    obrigatoria: boolean;
    ordem?: number;
  }) => void;
  proximaOrdem: number;
}) {
  const [descricao, setDescricao] = useState("");
  const [obrigatoria, setObrigatoria] = useState(false);
  const [ordem, setOrdem] = useState<number>(proximaOrdem);

  const handleOk = () => {
    onSubmit({ descricao, obrigatoria, ordem });
    setDescricao("");
    setObrigatoria(false);
    setOrdem(proximaOrdem);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Nova Pergunta</DialogTitle>
      <DialogContent>
        <Box mt={1} display="grid" gap={2}>
          <TextField
            label="Descrição"
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
            fullWidth
          />
          <TextField
            label="Ordem"
            type="number"
            value={ordem}
            onChange={(e) => setOrdem(Number(e.target.value))}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={obrigatoria}
                onChange={(e) => setObrigatoria(e.target.checked)}
              />
            }
            label="Obrigatória"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={handleOk}
          disabled={!descricao.trim()}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
